import * as actionTypes from './actionTypes';
import axios from '../../lib/axios/axios';
import axiosGolang from 'lib/axios/axios-golang';
import Moment from 'moment';
import {
  buildFlagBoxList,
  getChannelContextMsg,
  handleBlockScreen,
  handleKasbonAcctInq,
  isInvalidScheme,
  isObjectEmpty,
  isValidDate,
  mapCmCode,
  prependEmptyOption,
  sortFlagBoxs,
  validateSubCodeAndLoading,
  getChannelContextAdditionalInfo,
  hasOccupationInfoData
} from 'helpers/Utility';
import {
  USERS,
  USERSV2,
  CODE_REFERENCES,
  PROVINCE,
  COMPANY_INFO,
  VERIFY_PAYROLL,
  FIELD_OF_WORKS,
  FIELD_OF_BUSINESS,
  FIELD_JOB_TITLE,
  FIELD_DAILY_NORMAL_TRANSACTION,
  MAINTENANCE,
  STANDARD_TEXT,
  RELIGION,
  CITY,
  USERSV3
} from '../../common/config';
import {
  setHomePath,
  setError,
  getPartnerToken
  // resetError
} from './auth';
import { setTimer, setCreditScoreResult, setDisburseDetail } from './disburse';
import { getJsonStringify, getChannelContextCode } from '../../helpers/Utility';
import { sendEvent, sendException } from 'helpers/analytics';
import {
  COMPANY_NAME_ALTERNATIVE,
  OCH_DATE_FORMAT_SUBMISSION,
  PT_BANK_RAYA_INDONESIA,
  RETIRED_EMPLOYEE_AGE,
  SCHEME_CODE_KASBON,
  SCHEME_CODE_PNANG,
  SCHEME_CODE_PNNEW
} from 'common/constants';
import {
  handleApplicationStatus,
  handleApplicationStatusV3,
  handleDynamicPathOptions,
  handleEOD,
  handleFetchAccountRaya,
  handleFetchApplicationDetails,
  handleFetchDocument,
  handleSuccessPayrollVerification,
  handleSuccessResponsePutApplication,
  handleSuccessResubmitKtp,
  handleSuccessVerifyPayroll,
  setupCommonDispatch,
  setupCommonDispatchV3
} from './handleSuccessService/loanApplySuccessService';
import {
  handleApplicationError,
  handleApplicationPutError,
  handleErrorPayrollVerification,
  handleErrorResubmitKtp,
  handleErrorVerifyPayroll,
  handleFetchOptionsError,
  handleSecondLoanCreditScoringError,
  handleWhitelistError
} from './handleErrorService/loanApplyErrorService';
import { generateHmac } from 'helpers/generateHmac';

export const loading = val => {
  return {
    type: actionTypes.APP_LOADING,
    loading: val
  };
};

let controller = new AbortController();

export const applicationInquiry = (auth, history, params) => {
  return async (dispatch, getState) => {
    !params?.noLoading && dispatch(loading(true));

    const { longitude = '', latitude = '' } = getState().auth.geoLocation || {};
    const url = `${USERS}/custom/applicationInquiry?recordCount=1&longitude=${longitude}&latitude=${latitude}`;
    const { signature, timestamp } = generateHmac(
      'GET',
      'applicationinquiry',
      ''
    );

    try {
      const res = await axiosGolang.get(url, {
        headers: {
          Authorization: auth.token,
          'H-PNG-Signature': signature,
          'H-PNG-Timestamp': timestamp
        }
      });

      const data = res.data;
      const appStatus = data?.applicationStatus?.cmCode;
      const ekycStatus = data?.EkycStatus;
      const isExpired = data?.isExpired;
      const isExpiredLocalStorage = localStorage?.getItem('isExpired');
      const isEOD =
        data.rayanetEndOfDay === 'Y' || getState().auth.error === 'eod';

      // setup common states
      setupCommonDispatch(dispatch, data, getState);

      // show expired screen before any status handler runs
      if (isExpired && isExpiredLocalStorage !== 'Y') {
        dispatch(setApplicationId(data.applicationId));
        dispatch(loading(false));
        params?.expired?.(data);
        return;
      }

      // handle status-specific logic
      await handleApplicationStatus({
        dispatch,
        appStatus,
        data,
        auth,
        context: {
          params,
          ekycStatus,
          getState,
          history
        }
      });

      dispatch(setApplicationId(data.applicationId));

      // expired screen already acknowledged: continue to default path
      if (isExpired) {
        dispatch(loading(false));
        params?.defaultPath?.(data);
        params?.action?.();
        return;
      }

      //handle eod
      isEOD && handleEOD(params, history, appStatus, dispatch, data);

      if (data?.payrollDetails) {
        dispatch(rehydrateOccupationInfo(data?.payrollDetails));
      }

      params?.defaultPath?.(data);
      params?.action?.();
    } catch (err) {
      handleApplicationError(dispatch, err, auth, params);
    } finally {
      dispatch(loading(false));
    }
  };
};

// suplesi v3
export const applicationInquiryV3 = (auth, history, params) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));

    const url = `${USERSV3}/custom/application-suplesi-inquiry?recordCount=1`;

    const { signature, timestamp } = generateHmac(
      'GET',
      'applicationinquiry',
      ''
    );

    try {
      const res = await axiosGolang.get(url, {
        headers: {
          Authorization: auth.token,
          'H-PNG-Signature': signature,
          'H-PNG-Timestamp': timestamp
        }
      });

      const data = res.data;

      const appStatusSuplesi =
        data?.applicationStatusSuplesi?.cmCode || 'APP_EXPIRED';
      const ekycStatus = data?.EkycStatus;
      const isFlowSuplesiActive = getState().loanApply.isFlowSuplesiActive;

      // setup common states
      setupCommonDispatchV3(dispatch, data);

      const isExpired = data?.isExpired;
      const isExpiredLocalStorage = localStorage?.getItem('isExpired');

      if (isExpired) {
        dispatch(loading(false));

        if (isExpiredLocalStorage === 'Y') {
          params?.suplesiHome?.();
        } else {
          params?.expired?.(data);
        }

        return;
      }

      // handle status-specific logic
      handleApplicationStatusV3({
        dispatch,
        appStatusSuplesi,
        data,
        auth,
        context: {
          params,
          history,
          ekycStatus,
          isFlowSuplesiActive
        }
      });

      if (data?.payrollDetails) {
        dispatch(rehydrateOccupationInfo(data?.payrollDetails));
      }

      params?.defaultPath?.(data);
      params?.action?.();
    } catch (err) {
      handleApplicationError(dispatch, err, auth, params);
      dispatch(loading(false));
    }
  };
};

export const getMaintenance = (auth, params) => {
  return async (dispatch, getState) => {
    if (params?.loading) dispatch(loading(true));

    //referral from link auth
    const authRedux = getState().auth;
    const referralCode = authRedux?.referralCode;

    //if url has referral, add param referralCode
    const url = referralCode
      ? `${MAINTENANCE}?referralCode=${referralCode}`
      : MAINTENANCE;

    try {
      const header = { headers: { Authorization: auth.token } };

      const res = await axiosGolang.get(url, header);
      const resData = res.data?.data;
      const activeReferral = res.data?.referral?.isActive;
      const errorCode = res.data?.header?.status?.message?.[0]?.messageCode;

      // reset defaults
      dispatch(setBlockScreen({}));
      dispatch(setBottomSheet({}));
      dispatch(setFlagBoxs([]));

      // handle if referral isactive false set error
      if (
        referralCode &&
        (activeReferral === 'false' || errorCode === '0200')
      ) {
        params?.loading && dispatch(loading(false));
        dispatch(setError('referral_invalid'));
        return;
      }

      const findProperty = property =>
        resData?.find(data => data.property === property);

      const dataBlockScreen = findProperty('BLOCKSCREEN');
      const dataFlagBoxSheet = findProperty('FLAGBOXSHEET');
      const dataFlagBox = findProperty('FLAGBOX');

      if (dataBlockScreen?.activated) {
        handleBlockScreen(dispatch, dataBlockScreen);
        dispatch(loading(false));
        params?.success?.();
        return;
      }

      const flagBoxs = buildFlagBoxList(
        dispatch,
        dataFlagBoxSheet,
        dataFlagBox
      );

      if (flagBoxs.length > 0) {
        dispatch(setFlagBoxs(sortFlagBoxs(flagBoxs)));
      }

      params?.checkFlagBoxMaintenance?.(dataFlagBoxSheet?.activatedOn || []);
      params?.loading && dispatch(loading(false));
      params?.next?.();
      params?.appInqV3?.();
    } catch (err) {
      dispatch(loading(false));

      if (err.toString().includes('Network Error')) {
        dispatch(setError('connection'));
      } else if (
        getChannelContextAdditionalInfo(err, 'channel-context') === '555008'
      ) {
        dispatch(getPartnerToken());
      } else {
        dispatch(setError('system'));
      }
    } finally {
      dispatch(setMaintenanceWait(false));
    }
  };
};

export const rehydratePersonInfo = (
  applicantDetails,
  maritalStatusReference,
  ktpAddressDetails
) => {
  const valuesByUsingForm = (states, id) => {
    const { isUsingForm, bankCode, silverLakeCIF, verifyPayrollData } =
      states.loanApply;
    const { silverLakeCIFInquiryReferenceVO } = verifyPayrollData;
    const { sex: ktpAddrDetailsGender, agama: ktpAddrDetailsReligion } =
      ktpAddressDetails || {};
    const {
      gender: applicantDetailsGender,
      religion: applicantDetailsReligion
    } = applicantDetails || {};
    const { sex: cifGender, agama: cifReligion } =
      silverLakeCIF || silverLakeCIFInquiryReferenceVO || {};

    const getValue = (isUsingForm, ktpAddr, cif, personInfo) => {
      if (bankCode === '002') {
        if (isUsingForm === 'Y') {
          return ktpAddr || personInfo;
        } else {
          return personInfo;
        }
      } else {
        return cif || personInfo || ktpAddr;
      }
    };

    if (id === 'gender') {
      return getValue(
        isUsingForm,
        ktpAddrDetailsGender,
        cifGender,
        applicantDetailsGender
      );
    }

    if (id === 'religion') {
      return getValue(
        isUsingForm,
        ktpAddrDetailsReligion,
        cifReligion,
        applicantDetailsReligion
      );
    }

    return null;
  };

  const addressKtp = nameAddr => {
    const stringData = str =>
      typeof str === 'string' &&
      str.trim() !== '' &&
      str !== 'undefined' &&
      !str.includes('undefined')
        ? str
        : '';

    const objData = obj => {
      return obj && !isObjectEmpty(obj) ? obj : '';
    };

    const dataValue = [
      {
        id: 'fullAddressKtp',
        value: stringData(ktpAddressDetails?.address)
      },
      {
        id: 'rtKtp',
        value: stringData(ktpAddressDetails?.address2)
      },
      {
        id: 'rwKtp',
        value: stringData(ktpAddressDetails?.address3)
      },
      {
        id: 'provinsiKtp',
        value: objData(ktpAddressDetails?.provinceDetails)
      },
      {
        id: 'kotaKtp',
        value: objData(ktpAddressDetails?.cityDetails)
      },
      {
        id: 'kecamatanKtp',
        value: objData(ktpAddressDetails?.kecamatanDetails)
      },
      {
        id: 'desaKtp',
        value: objData(ktpAddressDetails?.kelurahanDetails)
      }
    ];

    const findValue = dataValue.find(data => data.id === nameAddr);
    const data = findValue?.value;

    return data;
  };

  const haveSameAddr = () => {
    const ktpValues = [
      ktpAddressDetails?.address,
      ktpAddressDetails?.address2,
      ktpAddressDetails?.address3,
      ktpAddressDetails?.provinceDetails?.cmCode,
      ktpAddressDetails?.cityDetails?.cmCode,
      ktpAddressDetails?.kecamatanDetails?.cmCode,
      ktpAddressDetails?.kelurahanDetails?.cmCode
    ];

    const applicantValues = [
      applicantDetails?.addressLine1,
      applicantDetails?.addressLine2,
      applicantDetails?.addressLine3,
      applicantDetails?.provinceDetails?.cmCode,
      applicantDetails?.city?.cmCode,
      applicantDetails?.addressLine4?.cmCode,
      applicantDetails?.addressLine5?.cmCode
    ];

    const compareAddress = () => {
      // Checking if empty return false
      if (ktpValues.some(v => !v) || applicantValues.some(v => !v))
        return false;

      // Checking if same address
      return ktpValues.every((v, i) => v === applicantValues[i]);
    };

    return compareAddress();
  };

  return (dispatch, getState) => {
    dispatch(
      setPersonInfo({
        email: applicantDetails.emailId,
        marriageStatus:
          applicantDetails?.maritalStatusReference || maritalStatusReference,
        mobileNo: applicantDetails.mobileNo,
        name: applicantDetails.name,
        gender: valuesByUsingForm(getState(), 'gender'), // still empty from the response
        placeOfBirth: applicantDetails.placeOfBirth,
        dateOfBirth: applicantDetails.dateOfBirth,
        nationalId: applicantDetails.nationalId,
        education: applicantDetails.lastEducation,
        // ktp address
        fullAddressKtp: addressKtp('fullAddressKtp'),
        rtKtp: addressKtp('rtKtp'),
        rwKtp: addressKtp('rwKtp'),
        kecamatanKtp: addressKtp('kecamatanKtp'),
        desaKtp: addressKtp('desaKtp'),
        provinsiKtp: addressKtp('provinsiKtp'),
        kotaKtp: addressKtp('kotaKtp'),
        postalCodeKtp:
          ktpAddressDetails?.postalCodeKtp?.toString() ||
          ktpAddressDetails?.zipCode?.toString(),
        // resedential address
        fullAddress: applicantDetails.addressLine1,
        rt: applicantDetails.addressLine2,
        rw: applicantDetails.addressLine3,
        kecamatan:
          typeof applicantDetails.addressLine4 === 'object' &&
          applicantDetails.addressLine4?.cmCode
            ? applicantDetails.addressLine4
            : '',
        desa:
          typeof applicantDetails.addressLine5 === 'object' &&
          applicantDetails.addressLine5?.cmCode
            ? applicantDetails.addressLine5
            : '',
        provinsi: applicantDetails.provinceDetails,
        kota: applicantDetails.city,
        postalCode: applicantDetails?.postalCode?.toString(),
        domisiliStatus: applicantDetails.homeOwnershipStatus,
        homeOwnershipDuration: applicantDetails.homeOwnershipDuration,
        // religion: valuesByUsingForm(getState(), 'religion'),
        religion: applicantDetails?.religion || ktpAddressDetails?.agama,
        haveSameAddress: haveSameAddr(),
        haveHousePhone: !!applicantDetails.homePhoneNumber,
        phone: applicantDetails.homePhoneNumber,
        stayPeriod: applicantDetails?.stayPeriod?.toString()
      })
    );
  };
};

export const rehydrateKtpAddressDetails = (ktpAddressDetails = {}) => {
  return dispatch => {
    const fields = [
      'address',
      'address2',
      'address3',
      'address4',
      'addressRT',
      'addressRW',
      'agama',
      'mailingAddress',
      'birthDate',
      'cifNo',
      'idNo',
      'idType',
      'nama',
      'placeOfBirth',
      'province',
      'sex',
      'zipCode',
      'bankCode',
      'dailyTrx',
      'education',
      'educationDesc',
      'email',
      'department',
      'departmentDesc',
      'kecamatan',
      'kelurahan',
      'maritalStatus',
      'mobileNumber',
      'officeAddress',
      'officeCity',
      'officeSubDistrict',
      'officeUrbanVillage',
      'officeName',
      'officeZipCode',
      'monthlyIncome',
      'pepFlag',
      'mainIncome',
      'mainIncomeDesc',
      'accountOpeningPurpose',
      'city',
      'partnerName',
      'partnerBirthDate',
      'partnerNikId',
      'reportingRelationship',
      'propertySeparationAgreement',
      'monthlyIncomeUser',
      'nameWithoutTitle'
    ];

    const normalized = Object.fromEntries(
      fields.map(field => [field, ktpAddressDetails[field] || ''])
    );

    dispatch(setKtpAddressDetails(normalized));
  };
};

/**
 *
 * @param {*} payrollDetails
 * @returns
 */
export const rehydrateOccupationInfo = (
  payrollDetails,
  accountRayaInformation = {},
  ktpAddressDetails = {},
  respPayrollDetails = {}
) => {
  const validateFieldOfBussinessOccupationInfo = () => {
    if (payrollDetails.businessFieldsCode) {
      if (payrollDetails.businessFieldsCode.length > 4) return '';
      else return payrollDetails.businessFieldsCode;
    } else if (payrollDetails.fieldOfBusiness) {
      return payrollDetails.fieldOfBusiness;
    } else return '';
  };

  const validateFieldOfSubBussinessOccupationInfo = () => {
    if (
      payrollDetails.subBusinessFieldsCode &&
      payrollDetails.subBusinessFieldsDesc
    ) {
      if (payrollDetails.businessFieldsCode.length === 4)
        return payrollDetails.subBusinessFieldsCode;
      else return '';
    } else if (payrollDetails.fieldOfSubBusiness) {
      return payrollDetails.fieldOfSubBusiness;
    } else return '';
  };

  const validateCompanyAddress = () => {
    if (payrollDetails.workAddress) {
      return payrollDetails.workAddress.substring(0, 255);
    } else if (payrollDetails.companyAddress) {
      return payrollDetails.companyAddress.substring(0, 255);
    } else return '';
  };

  const validateCompanyName = state => {
    const companyName = payrollDetails?.companyName;
    const companyName2 = payrollDetails?.companyName2;

    if (state.loanApply.isRayaEmployed === 'Y') return PT_BANK_RAYA_INDONESIA;

    if (companyName !== COMPANY_NAME_ALTERNATIVE)
      return companyName?.length > 50
        ? companyName?.substring(0, 50)
        : companyName;
    else if (companyName2)
      return companyName2?.length > 50
        ? companyName2?.substring(0, 50)
        : companyName2;
    else return companyName;
  };

  const geRehydrateDataOpeningSaving = id => {
    const isFullCompanyRegion =
      !isObjectEmpty(payrollDetails.companyState) &&
      !isObjectEmpty(payrollDetails.companyCity) &&
      !isObjectEmpty(payrollDetails.companyDistrict) &&
      !isObjectEmpty(payrollDetails.companySubDistrict);

    const sources = {
      fileNpwp: [payrollDetails.fileNpwp, accountRayaInformation?.fileNpwp, ''],
      jobTitle: [
        payrollDetails.jobTitle,
        accountRayaInformation?.jabatanPekerjaan?.cmCode,
        ktpAddressDetails?.department,
        ''
      ],
      jobTitleDesc: [
        payrollDetails.jobTitleDesc,
        accountRayaInformation?.jabatanPekerjaan?.codeDescription,
        ktpAddressDetails?.departmentDesc,
        ''
      ],
      provinceOfWork: [
        payrollDetails.provinceOfWork,
        isFullCompanyRegion ? payrollDetails.companyState?.cmCode : '',
        accountRayaInformation?.provinsiTempatBekerja?.cmCode,
        ''
      ],
      provinceOfWorkDesc: [
        payrollDetails.provinceOfWorkDesc,
        isFullCompanyRegion ? payrollDetails.companyState?.codeDescription : '',
        accountRayaInformation?.provinsiTempatBekerja?.codeDescription,
        ''
      ],
      cityOfWork: [
        payrollDetails.cityOfWork,
        isFullCompanyRegion ? payrollDetails.companyCity?.cmCode : '',
        accountRayaInformation?.kotaTempatBekerja?.cmCode,
        ''
      ],
      cityOfWorkDesc: [
        payrollDetails.cityOfWorkDesc,
        isFullCompanyRegion ? payrollDetails.companyCity?.codeDescription : '',
        accountRayaInformation?.kotaTempatBekerja?.codeDescription,
        ''
      ],
      districtOfWork: [
        payrollDetails.districtOfWork,
        isFullCompanyRegion ? payrollDetails.companyDistrict?.cmCode : '',
        accountRayaInformation?.kecamatanTempatBekerja?.cmCode,
        ''
      ],
      districtOfWorkDesc: [
        payrollDetails.districtOfWorkDesc,
        isFullCompanyRegion
          ? payrollDetails.companyDistrict?.codeDescription
          : '',
        accountRayaInformation?.kecamatanTempatBekerja?.codeDescription,
        ''
      ],
      wardOfWork: [
        payrollDetails.wardOfWork,
        isFullCompanyRegion ? payrollDetails.companySubDistrict?.cmCode : '',
        accountRayaInformation?.kelurahanTempatBekerja?.cmCode,
        ''
      ],
      wardOfWorkDesc: [
        payrollDetails.wardOfWorkDesc,
        isFullCompanyRegion
          ? payrollDetails.companySubDistrict?.codeDescription
          : '',
        accountRayaInformation?.kelurahanTempatBekerja?.codeDescription,
        ''
      ],
      postalCodeOfWork: [
        payrollDetails.postalCodeOfWork,
        payrollDetails.companyPostalCode,
        accountRayaInformation?.kodePosTempatBekerja,
        ''
      ],
      workPhoneNumber: [
        payrollDetails.workPhoneNumber,
        accountRayaInformation?.noTlpTempatBekerja,
        ''
      ],
      dailyNormalTransactions: [
        payrollDetails.dailyNormalTransactions,
        accountRayaInformation?.transaksiNormalHarian?.cmCode,
        ''
      ],
      dailyNormalTransactionsDesc: [
        payrollDetails.dailyNormalTransactionsDesc,
        accountRayaInformation?.transaksiNormalHarian?.codeDescription,
        ''
      ],
      watch: [
        payrollDetails.npwp ||
        (accountRayaInformation?.npwp && accountRayaInformation.fileNpwp)
          ? 'Y'
          : 'N'
      ]
    };

    const candidates = sources[id];
    if (!candidates) return '';

    return (
      candidates.find(val => val !== undefined && val !== null && val !== '') ??
      ''
    );
  };

  const validateEmpEndDate = (employeeStatus, empEndDateWL, getString) => {
    // valid empEndDateWL
    if (isValidDate(empEndDateWL)) {
      return empEndDateWL;
    }

    // not valid empEndDateWL and employeeStatus != tetap
    if (employeeStatus.toLowerCase() !== 'tetap') {
      return '';
    }

    // not valid empEndDateWL and employeeStatus == tetap
    const birthDateWL =
      respPayrollDetails.birthDateWL || payrollDetails.birthDateWL;

    const endWorkingDate = Moment(birthDateWL)
      .startOf('day')
      .add(RETIRED_EMPLOYEE_AGE, 'year')
      .format(OCH_DATE_FORMAT_SUBMISSION);

    return getString(endWorkingDate);
  };

  return (dispatch, getState) => {
    const {
      purposeOfOpenAcct,
      addressWL,
      birthDateWL,
      employeeStatus,
      empEndDateWL,
      fieldOfBusinessDesc,
      businessFieldsDesc,
      fieldOfSubBusinessDesc,
      subBusinessFieldsDesc,
      fieldOfWork,
      workingCode,
      fieldOfWorkDesc,
      workingDesc,
      genderWL,
      netIncomeWL,
      nameWL,
      npwp: npwpPayroll,
      expenditureAmount,
      payrollDate,
      payrollAccount,
      payrollAccountBranch,
      placeOfBirthWL,
      savingAccOwnshpSts,
      savingAmount,
      sourceOfIncome,
      empStartDateWL,
      typeOfWork
    } = payrollDetails;

    const getData = key => geRehydrateDataOpeningSaving(key);
    const getString = (value, fallback = '') => value || fallback;
    const getNumber = (value, fallback = 0) => value || fallback;

    const companyFields = ['companyName', 'companyName2'];
    const isCompanyOnlyPayload = Object.keys(payrollDetails || {}).every(key =>
      companyFields.includes(key)
    );

    if (isCompanyOnlyPayload) {
      const { occupationInfo } = getState().loanApply;
      const existingOccupationInfo =
        occupationInfo && typeof occupationInfo === 'object'
          ? occupationInfo
          : {};

      const hasExistingOccupationData = hasOccupationInfoData(
        existingOccupationInfo
      );

      const companyName = getString(validateCompanyName(getState()));

      if (hasExistingOccupationData) {
        dispatch(
          setOccupationInfo({
            ...existingOccupationInfo,
            companyName,
            companyName2: companyName
          })
        );
        return;
      }
    }

    dispatch(
      setOccupationInfo({
        accountPurpose: getString(purposeOfOpenAcct),
        addressWL: getString(addressWL),
        birthDateWL: getString(birthDateWL),
        companyAddress: validateCompanyAddress(),
        companyName: getString(validateCompanyName(getState())),
        companyName2: getString(validateCompanyName(getState())),
        employeeStatus: getString(employeeStatus),
        endWorkingDate: validateEmpEndDate(
          getString(employeeStatus),
          getString(empEndDateWL),
          getString
        ),
        fieldOfBusiness: validateFieldOfBussinessOccupationInfo(),
        fieldOfBusinessDesc: getString(fieldOfBusinessDesc, businessFieldsDesc),
        fieldOfSubBusiness: validateFieldOfSubBussinessOccupationInfo(),
        fieldOfSubBusinessDesc: getString(
          fieldOfSubBusinessDesc,
          subBusinessFieldsDesc
        ),
        fieldOfWork: getString(fieldOfWork, workingCode),
        fieldOfWorkDesc: getString(fieldOfWorkDesc, workingDesc),
        genderWL: getString(genderWL),
        income: getNumber(netIncomeWL),
        nameWL: getString(nameWL),
        npwp: getString(npwpPayroll, accountRayaInformation?.npwp),
        outcome: getNumber(expenditureAmount),
        payDay: payrollDate ? new Date(payrollDate).getDate() : 0,
        payrollAccount: getString(payrollAccount),
        payrollAccountBranch: getString(payrollAccountBranch),
        payrollDate: getString(payrollDate),
        placeOfBirthWL: getString(placeOfBirthWL),
        savingAccOwnshpSts: getString(savingAccOwnshpSts),
        savingAmount: getNumber(savingAmount),
        sourceOfIncome: getString(sourceOfIncome),
        startWorkingDate: getString(empStartDateWL),
        typeOfWork: getString(typeOfWork),

        // rehydrate data
        fileNpwp: getData('fileNpwp'),
        jobTitle: getData('jobTitle'),
        jobTitleDesc: getData('jobTitleDesc'),
        provinceOfWork: getData('provinceOfWork'),
        provinceOfWorkDesc: getData('provinceOfWorkDesc'),
        cityOfWork: getData('cityOfWork'),
        cityOfWorkDesc: getData('cityOfWorkDesc'),
        districtOfWork: getData('districtOfWork'),
        districtOfWorkDesc: getData('districtOfWorkDesc'),
        wardOfWork: getData('wardOfWork'),
        wardOfWorkDesc: getData('wardOfWorkDesc'),
        postalCodeOfWork: getData('postalCodeOfWork'),
        workPhoneNumber: getData('workPhoneNumber'),
        dailyNormalTransactions: getData('dailyNormalTransactions'),
        dailyNormalTransactionsDesc: getData('dailyNormalTransactionsDesc'),
        watch: getData('watch')
      })
    );
  };
};

export const rehydrateFamilyInfo = contactInformation => {
  return dispatch => {
    dispatch(
      setFamilyInfo({
        emergencyNumber: String(contactInformation.contactNumber || ''),
        marriageStatus: contactInformation.maritalStatusReference,
        mothersMaidenName: contactInformation.motherName,
        numberOfDependents: contactInformation.noOfDependent,
        relationshipWithRelatives: contactInformation.relationshipReference,
        relativesName: contactInformation.contactName,
        contactAddress: contactInformation.emergencyContactAddress || '',
        spouseIdNo:
          contactInformation.spouseId !== '0'
            ? contactInformation.spouseId
            : contactInformation.partnerNikId
      })
    );
  };
};

export const fetchDocRiplay = (auth, param) => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    const isUserLoyalty = getState().loanApply.appInqRes.isUserLoyalty;

    const url =
      param?.docType === 'DTRPC'
        ? STANDARD_TEXT +
          param?.docType +
          '&plafond=' +
          param?.plafond +
          '&tenor=' +
          param?.tenor +
          '&monthlyInstallment=' +
          param?.monthlyInstallment +
          '&appId=' +
          auth?.applicationId +
          '&serviceFeePercentage=' +
          param?.serviceFeePercentage +
          '&serviceFeeAmount=' +
          param?.serviceFeeAmount
        : STANDARD_TEXT + param?.docType;

    const header = {
      headers: {
        Authorization: auth.token
      }
    };

    axiosGolang
      .get(`${url}&isUserLoyalty=${isUserLoyalty}`, header)
      .then(res => {
        dispatch(setDocRiplay(res.data.data));
        param && param.action && param.action();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const fetchApplicationData = (auth, param) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));
    const appId = auth.prevAppId || auth.applicationId;
    const url = `${USERS}/custom/applications/${appId}`;

    const { signature, timestamp } = generateHmac('GET', 'applications', '');

    const header = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    try {
      const { data } = await axiosGolang.get(url, header);
      if (!data) throw new Error('No data');

      dispatch(setApplicationdata(data));
      dispatch(setRespPayrollDetails(data?.respPayrollDetails));
      dispatch(
        setApplicationStatus(
          data?.applicationDetails?.applicationStatus?.cmCode
        )
      );
      handleFetchDocument(dispatch, data.documentDetails);

      handleFetchApplicationDetails(dispatch, data, getState);

      handleFetchAccountRaya(dispatch, data.accountRayaInformation);

      if (!param?.loading) dispatch(loading(false));

      const state = getState().loanApply;
      param?.action?.({
        ktp: state.eKTP || state.applicationDetails?.ktpNum,
        cardNumber:
          state.camscall?.accountNumber ||
          state.occupationInfo?.payrollAccount ||
          state.respPayrollDetails?.payrollAccount,
        bankCode: state.bankCode,
        token: getState().auth.oauthToken,
        schemeCode: state.appInqRes?.schemeCode,
        subCode: getState().auth.subCode
      });
    } catch (err) {
      const isNetworkError = err.toString().includes('Network Error');
      dispatch(setError(isNetworkError ? 'connection' : 'system'));
      dispatch(loading(false));
    }
  };
};

//suplesi
export const fetchApplicationDataV3 = (auth, param) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));
    const appId = auth.prevAppId || auth.applicationId;
    const url = `${USERSV3}/custom/suplesi/${appId}`;

    const { signature, timestamp } = generateHmac('GET', 'applications', '');

    const header = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    try {
      const { data } = await axiosGolang.get(url, header);
      if (!data) throw new Error('No data');

      dispatch(setApplicationdata(data));
      handleFetchDocument(dispatch, data.documentDetails);

      handleFetchApplicationDetails(dispatch, data, getState);

      handleFetchAccountRaya(dispatch, data.accountRayaInformation);

      if (!param?.loading) dispatch(loading(false));

      const state = getState().loanApply;
      param?.action?.({
        ktp: state.eKTP || state.applicationDetails?.ktpNum,
        cardNumber:
          state.camscall?.accountNumber ||
          state.occupationInfo?.payrollAccount ||
          state.respPayrollDetails?.payrollAccount,
        bankCode: state.bankCode,
        token: getState().auth.oauthToken,
        schemeCode: state.appInqRes?.schemeCode,
        subCode: getState().auth.subCode
      });
    } catch (err) {
      const isNetworkError = err.toString().includes('Network Error');
      dispatch(setError(isNetworkError ? 'connection' : 'system'));
      dispatch(loading(false));
    }
  };
};

export const fetchingOptionSelect = (options, action = undefined) => {
  return async dispatch => {
    let promises = options.map(option => dispatch(fetchOptions(option)));
    let result = await Promise.all(promises).then(() => {
      action && action();
    });
    return result;
  };
};

export const fetchLoanScheme = (auth, param) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));

    const { partnerId, subCode: authSubCode } = getState().auth;

    const { appInqRes = {}, applicationStatus } = getState().loanApply;

    const url = `${USERS}/custom/loanNewSchemeCodes?partnerId=${partnerId}`;
    const header = { headers: { Authorization: auth.token } };

    const allowedAppStatus = [
      'LOAN_PAID',
      'APP_EXPIRED',
      'APP_CREATED',
      'USR_REJECT',
      'CR_SCORE_REJ',
      'PAYROLL_REJ',
      'LOAN_CREATED'
    ];

    const allowedFlexiSchemeCodes = [
      SCHEME_CODE_PNANG,
      SCHEME_CODE_PNNEW,
      SCHEME_CODE_KASBON
    ];

    const webviewSaving = [{ schemeCode: SCHEME_CODE_PNANG, subCode: 'RAYA' }];

    // set chosen scheme
    const appSchemeCode = appInqRes.schemeCode;

    // variable to set and parsing sub code list in breakUpDetails
    let breakUpDetailsList = [];

    // variable to set and parsing loan scheme code
    let loanSchemeCodes = [];

    try {
      const res = await axiosGolang.get(url, header);
      const loanSchemes = res.data?.data;

      if (!loanSchemes) return dispatch(setError('system'));

      dispatch(setLoanSchemes(loanSchemes));

      if (loanSchemes[0]?.breakUpDetailsList) {
        // set list sub code to redux
        dispatch(setSubCodeLoanScheme(loanSchemes[0].breakUpDetailsList));

        // set breakUpDetails to variable
        breakUpDetailsList = loanSchemes[0]?.breakUpDetailsList;
      }

      if (
        (appSchemeCode &&
          appInqRes.applicationStatus?.cmCode !== 'LOAN_PAID') ||
        (appInqRes.applicationStatus?.cmCode !== 'LOAN_CREATED' &&
          appInqRes.suplesiData?.applicationStatus?.cmCode !== 'APP_EXPIRED')
      ) {
        const chosenScheme = loanSchemes.find(
          item => item.schemeCode === appSchemeCode
        ) || {
          schemeCode: appSchemeCode
        };
        dispatch(setLoanScheme(chosenScheme));
      }

      // set loan scheme code to variable
      loanSchemeCodes = loanSchemes.map(s => s.schemeCode);
    } catch (err) {
      if (err.toString().includes('Network Error')) {
        dispatch(setError('connection'));
      } else {
        dispatch(setError('system'));
      }
    } finally {
      const isInvalidSchemeCode = isInvalidScheme({
        schemeCode: appSchemeCode,
        subCode: appInqRes.subCode || '',
        loanSchemeCodes,
        authSubCode,
        appInqRes,
        allowedAppStatus,
        allowedFlexiSchemeCodes,
        webviewSaving
      });

      validateSubCodeAndLoading({
        partnerId,
        breakUpDetailsList,
        authSubCode,
        applicationStatus,
        dispatch,
        param,
        isInvalidSchemeCode
      });
    }
  };
};

export const fetchLoanProduct = (auth, param) => {
  return (dispatch, getState) => {
    dispatch(loading(true));
    const isUserLoyalty = getState().loanApply.appInqRes.isUserLoyalty;
    const url =
      USERS + '/' + `custom/loanproducts?isUserLoyalty=${isUserLoyalty}`;
    const header = {
      headers: {
        Authorization: auth.token
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        res.data.data && dispatch(setLoanProduct(res.data.data));
        param && param.action && param.action();
      })
      .catch(err => {
        dispatch(loading(false));

        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        param?.loading && dispatch(loading(false));
      });
  };
};

export const fetchCustCategory = (auth, param) => {
  return dispatch => {
    dispatch(loading(true));
    const url = USERSV2 + '/' + 'custom/applications/custcategory';

    const { signature, timestamp } = generateHmac('GET', 'applications', '');

    const header = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        res.data.data && dispatch(setCustCategory(res.data.data));
        param?.action();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      })
      .finally(() => {
        if (auth.isSecondApply !== 'Y') dispatch(loading(false));
      });
  };
};

export const fetchBankCodes = (token, action) => {
  return dispatch => {
    dispatch(loading(true));
    const url = USERS + '/' + 'custom/bankcodes/002';
    const header = {
      headers: {
        Authorization: token
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        if (res.data.data) {
          dispatch(
            setBankOptions(
              [{ value: '', label: '' }].concat(
                res.data.data[0].bankDetails.map(x => {
                  return {
                    value: x.bankCode,
                    label: x.bankName
                  };
                })
              )
            )
          );
          action && action();
          return;
        }
      })
      .catch(err => {
        dispatch(loading(false));

        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      });
  };
};

export const verifyPayroll = (data, action, param) => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    const url = USERS + VERIFY_PAYROLL;
    const header = { headers: { Authorization: data.token } };
    const body = { schemeCode: data.schemeCode, subCode: data.subCode };

    axiosGolang
      .post(url, body, header)
      .then(res => {
        const resData = res.data?.data;
        handleSuccessVerifyPayroll(dispatch, resData, param, action, getState);
      })
      .catch(err => handleErrorVerifyPayroll(dispatch, err));
  };
};

export const payrollVerification = (auth, body, action, history) => {
  return (dispatch, getState) => {
    dispatch(setApplicationDetails(body));
    dispatch(loading(true));

    const url = `${USERS}/custom/applications`;

    const { signature, timestamp } = generateHmac('POST', 'applications', body);

    const header = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    axiosGolang
      .post(url, body, header)
      .then(res =>
        handleSuccessPayrollVerification(dispatch, res, body, action, getState)
      )
      .catch(err =>
        handleErrorPayrollVerification(dispatch, err, auth, history)
      )
      .finally(() => dispatch(loading(false)));
  };
};

//suplesi
export const payrollVerificationV3 = (auth, body, action, history) => {
  return (dispatch, getState) => {
    dispatch(setApplicationDetails(body));
    dispatch(loading(true));

    const url = `${USERSV3}/custom/suplesi`;

    const { signature, timestamp } = generateHmac('POST', 'applications', body);

    const header = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    axiosGolang
      .post(url, body, header)
      .then(res =>
        handleSuccessPayrollVerification(
          dispatch,
          res,
          body,
          action,
          getState,
          true
        )
      )
      .catch(err =>
        handleErrorPayrollVerification(dispatch, err, auth, history)
      )
      .finally(() => dispatch(loading(false)));
  };
};

export const submitUserDetails = (auth, param) => {
  return dispatch => {
    const url =
      USERS +
      '/' +
      (localStorage.getItem('phonePrincipal') || auth.phoneNo) +
      '/custom/' +
      COMPANY_INFO;
    const header = {
      headers: {
        Authorization: auth.token
      }
    };
    const body = {
      companyName: param.companyName,
      companyAddress: param.companyAddress
    };

    axios
      .post(url, body, header)
      .then(() => {
        param && param.action();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const updateReferralCode = (auth, body, action) => {
  return (dispatch, getState) => {
    const url = `${USERS}/custom/applications/${auth.applicationId}`;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const config = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    dispatch(loading(true));
    dispatch(setError(''));

    axiosGolang
      .put(url, body, config)
      .then(() => {
        const appInqRes = getState().loanApply.appInqRes;
        const newAppInqRes = { ...appInqRes, referralCode: body.referralCode };
        dispatch({
          type: actionTypes.SET_APP_INQUIRY_RESPONSE,
          res: newAppInqRes
        });

        action?.finish?.();
      })
      .catch(err => {
        const code = getChannelContextCode(err, 'channel-context');

        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }
        if (code === '1041') {
          dispatch(
            setBottomSheet({
              openBottomSheet: true,
              tittleBottomSheet: 'Kode referral tidak ditemukan',
              descriptionBottomSheet:
                'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
            })
          );
          return;
        }

        if (code === '1042') {
          dispatch(
            setBottomSheet({
              openBottomSheet: true,
              tittleBottomSheet: 'Kode referral tidak aktif',
              descriptionBottomSheet:
                'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
            })
          );
          return;
        }

        if (code === '1043') {
          dispatch(
            setBottomSheet({
              openBottomSheet: true,
              tittleBottomSheet: 'Kode referral tidak dapat digunakan',
              descriptionBottomSheet:
                'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
            })
          );
          return;
        }

        if (code === '1044') {
          dispatch(
            setBottomSheet({
              openBottomSheet: true,
              tittleBottomSheet: 'Kode referral kedaluwarsa',
              descriptionBottomSheet:
                'Silakan periksa kembali kode referral kamu atau lanjutkan tanpa menggunakan referral.'
            })
          );
          return;
        }

        dispatch(setError('system'));
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const resubmitKTP = (auth, body, action) => {
  return dispatch => {
    dispatch(loading(true));
    const url = `${USERS}/custom/applications/${auth.applicationId}`;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const config = {
      signal: controller.signal,
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    dispatch(setError(''));

    axiosGolang
      .put(url, body, config)
      .then(res => handleSuccessResubmitKtp(dispatch, res, action))
      .catch(err => handleErrorResubmitKtp(dispatch, err, auth))
      .finally(() => {
        dispatch(loading(false));
        action.show?.();
      });
  };
};

/**
 * get city for place of birth
 * @param callback
 * @returns {(function(*, *): void)|*}
 */
export const fetchPlaceOfBirthOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(CITY, { headers: { Authorization: getState().auth.oauthToken } })
      .then(res => {
        dispatch(
          setPlaceOfBirthOptions(
            [
              {
                value: '',
                label: ''
              }
            ].concat(
              res.data.map(data => {
                return {
                  value: data.cityCode,
                  label: data.cityDescription
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        dispatch(setHomePath('/continue-apply'));
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const ktpSubmitForm = (auth, body, action) => {
  return dispatch => {
    dispatch(loading(true));

    const url = USERS + '/' + 'custom/applications/' + auth.applicationId;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const header = {
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(res => {
        const data = res.data.data;

        if (data) {
          if (
            !isObjectEmpty(data?.ktpValidation) &&
            data?.ktpValidation?.code === '40000'
          ) {
            dispatch(loading(false));
            action?.failed?.();
            return;
          }

          dispatch(setKtpSubmitFormRes(data));

          action?.action?.();
        }
      })
      .catch(err => {
        dispatch(loading(false));
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }
        // COCD ERROR
        if (
          getChannelContextCode(err, 'channel-context') === '1005' ||
          getChannelContextCode(err, 'channel-context') === '1006' ||
          getChannelContextMsg(err, 'channel-context').includes(
            'No data found on ececuser.commoncodes'
          )
        ) {
          dispatch(setError('error_cocd'));
          return;
        }
        dispatch(setError('system'));
      });
  };
};

export const submitForm = (param, body, action) => {
  return async dispatch => {
    dispatch(loading(true));

    const url = `${USERS}/custom/applications/${param.applicationId}`;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    try {
      const res = await axiosGolang.put(url, body, header);
      const ok = res.status.toString().startsWith('2');

      if (ok) {
        handleSuccessResponsePutApplication(dispatch, res, param, body, action);
        return true;
      }

      return false;
    } catch (err) {
      handleApplicationPutError(dispatch, err);
    } finally {
      dispatch(loading(false));
    }
  };
};

//suplesi
export const submitFormV3 = (param, body, action) => {
  return async dispatch => {
    dispatch(loading(true));

    const url = `${USERSV3}/custom/suplesi/${param.applicationId}`;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    try {
      const res = await axiosGolang.put(url, body, header);
      const ok = res.status.toString().startsWith('2');

      if (ok) {
        handleSuccessResponsePutApplication(dispatch, res, param, body, action);
        return true;
      }

      return false;
    } catch (err) {
      handleApplicationPutError(dispatch, err);
    } finally {
      dispatch(loading(false));
    }
  };
};

export const fetchProvinceOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(PROVINCE, { headers: { Authorization: getState().auth.oauthToken } })
      .then(res => {
        dispatch(
          setProvinceOptions(
            [{ value: '', label: '' }].concat(
              res.data.map(data => {
                return {
                  value: data.stateCode,
                  label: data.stateDescription
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        dispatch(setHomePath('/continue-apply'));
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const fetchFieldOfBusinessOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(FIELD_OF_BUSINESS, {
        headers: { Authorization: getState().auth.oauthToken }
      })
      .then(res => {
        dispatch(
          setFieldOfBusinessOptions(
            [{ value: '', label: '' }].concat(
              res.data.map(data => {
                return {
                  value: data.cmCode,
                  label: data.codeDescription
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }

        // COCD ERROR
        if (
          getChannelContextCode(err, 'channel-context') === '105265' ||
          getChannelContextCode(err, 'channel-context') === '1003'
        ) {
          dispatch(setError('error_cocd'));
          return;
        }

        dispatch(setError('system'));
        dispatch(loading(false));
      });
  };
};

export const fetchFieldOfWorkOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(FIELD_OF_WORKS, {
        headers: { Authorization: getState().auth.oauthToken }
      })
      .then(res => {
        dispatch(
          setFieldOfWorkOptions(
            [{ value: '', label: '' }].concat(
              res.data.map(data => {
                return {
                  value: data.cmCode,
                  label: data.codeDescription
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }

        // COCD ERROR
        if (
          getChannelContextCode(err, 'channel-context') === '105265' ||
          getChannelContextCode(err, 'channel-context') === '1003'
        ) {
          dispatch(setError('error_cocd'));
          return;
        }

        dispatch(setError('system'));
        dispatch(loading(false));
      });
  };
};

export const fetchFieldOfJobTitleOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(USERS + FIELD_JOB_TITLE, {
        headers: { Authorization: getState().auth.oauthToken }
      })
      .then(res => {
        dispatch(
          setJobTitleOptions(
            [{ value: '', label: '' }].concat(
              res.data.data.listItem.map(data => {
                return {
                  key: data.key,
                  value: data.value
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        dispatch(setHomePath('/continue-apply'));
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const fetchFieldOfDailyNormalTransactionsOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(USERS + FIELD_DAILY_NORMAL_TRANSACTION, {
        headers: { Authorization: getState().auth.oauthToken }
      })
      .then(res => {
        dispatch(
          setDailyNormalTransactionsOptions(
            [{ value: '', label: '' }].concat(
              res.data.data.listItem.map(data => {
                return {
                  key: data.key,
                  value: data.value
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        dispatch(setHomePath('/continue-apply'));
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const fetchFieldOfReligionOptions = callback => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    axiosGolang
      .get(USERS + RELIGION, {
        headers: { Authorization: getState().auth.oauthToken }
      })
      .then(res => {
        dispatch(
          setReligionsOptions(
            [{ value: '', label: '' }].concat(
              res.data.data.listItem.map(data => {
                return {
                  value: data.key,
                  label: data.value
                };
              })
            )
          )
        );

        callback && callback();
      })
      .catch(err => {
        dispatch(setHomePath('/continue-apply'));
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

/**
 * Get list from API to be filled up on UI
 * @param path
 * @param code
 * @param callback after success get list
 * @returns {function(...[*]=)}
 */
export const fetchOptions = (path, code, callback = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));
    const basePath = path.split('?')[0];
    // /CNY is now always paginated on the backend
    const requestPath =
      basePath === '/CNY' && !path.includes('?')
        ? '/CNY?page=1&limit=20'
        : path;
    const url = CODE_REFERENCES + requestPath;
    const header = {
      headers: {
        Authorization: getState().auth.oauthToken
      }
    };

    try {
      const res = await axiosGolang.get(url, header);
      const data = res.data;

      // centralized mapping
      const pathHandlers = {
        '/LNPS': () =>
          dispatch(setLoanPurposeOptions(prependEmptyOption(mapCmCode(data)))),
        '/EDU': () =>
          dispatch(setEducationOptions(prependEmptyOption(mapCmCode(data)))),
        '/RES': () =>
          dispatch(setResidenceOptions(prependEmptyOption(mapCmCode(data)))),
        '/CTOW': () =>
          dispatch(setTypeOfWorkOptions(prependEmptyOption(mapCmCode(data)))),
        '/EMES': () =>
          dispatch(
            setEmployeeOptions(
              prependEmptyOption(
                data.map(d => ({
                  value: d.codeDescription,
                  label: d.codeDescription
                }))
              )
            )
          ),
        '/CPOA': () =>
          dispatch(
            setPurposeOfOpeningAccountOptions(
              prependEmptyOption(mapCmCode(data))
            )
          ),
        '/CSOI': () =>
          dispatch(
            setSourceOfIncomeOptions(prependEmptyOption(mapCmCode(data)))
          ),
        '/CNY': () =>
          dispatch(
            setCompanyOptions(
              (Array.isArray(data) ? data : data?.data || []).map(d => ({
                value: d.codeDescription,
                label: d.codeDescription,
                cmCode: d.cmCode
              }))
            )
          ),
        '/MST': () =>
          dispatch(setMarriageOptions(prependEmptyOption(mapCmCode(data)))),
        '/DEPN': () =>
          dispatch(setDependentsOptions(prependEmptyOption(mapCmCode(data)))),
        '/RLT': () =>
          dispatch(setRelativesOptions(prependEmptyOption(mapCmCode(data))))
      };

      if (pathHandlers[basePath]) {
        pathHandlers[basePath]();
      } else if (/\d/.test(basePath)) {
        handleDynamicPathOptions(dispatch, code, data);
      }

      callback?.();
    } catch (err) {
      dispatch(loading(false));
      handleFetchOptionsError(dispatch, err, path);
    }
  };
};

// Dedicated paginated fetch for the company-name /CNY drawer
export const fetchCompanyOptions = (
  {
    page = 1,
    limit = 20,
    companyName = '',
    codeCompany = '',
    append = false
  } = {},
  callback = () => {}
) => {
  return async (dispatch, getState) => {
    // Loading more company options loaded from backend
    dispatch(setCompanyLoadingMore(true));

    const query =
      `?page=${page}&limit=${limit}` +
      (codeCompany ? `&codeCompany=${codeCompany}` : '') +
      (companyName ? `&companyName=${encodeURIComponent(companyName)}` : '');
    const url = CODE_REFERENCES + '/CNY' + query;
    const header = {
      headers: {
        Authorization: getState().auth.oauthToken
      }
    };

    try {
      const res = await axiosGolang.get(url, header);
      const rawList = res.data?.data || [];
      const options = rawList.map(d => ({
        value: d.codeDescription,
        label: d.codeDescription,
        cmCode: d.cmCode
      }));
      const pagination = res.data?.pagination || null;

      if (append) dispatch(appendCompanyOptions(options));
      else dispatch(setCompanyOptions(options));
      dispatch(setCompanyPagination(pagination));

      callback?.(pagination);
    } catch (err) {
      handleFetchOptionsError(dispatch, err, '/CNY');
    } finally {
      dispatch(setCompanyLoadingMore(false));
    }
  };
};

export const submitCreditScoring = (param, body, action) => {
  return dispatch => {
    dispatch(loading(true));
    const url = USERS + '/' + 'custom/applications/' + param.applicationId;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(res => {
        dispatch(setCreditScoringRes(res.data.data));
        dispatch(
          setApplicationStatus(res.data.data?.applicationStatus?.cmCode)
        );
        localStorage.setItem('setCSFromFormFill', 1);
        dispatch(
          setTimer({
            minutes: res.data.data.timeLeftForScoreCompletion,
            seconds: 0
          })
        );
        dispatch(setCreditScoreResult(''));
        action && action();
      })
      .catch(err => {
        dispatch(setHomePath('/continue-apply'));
        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }

        if (getChannelContextCode(err, 'channel-context') === null) {
          dispatch(setError('system'));
          return;
        }

        // OCR FAILED
        if (getChannelContextCode(err, 'channel-context') === '211051') {
          dispatch(setError('OCR_FAILED'));
          return;
        }

        // PAYROLL ERROR
        if (getChannelContextCode(err, 'channel-context') === '211101') {
          dispatch(setError('PAYROLL_ERROR'));
          return;
        }

        // COCD ERROR
        if (
          getChannelContextCode(err, 'channel-context') === '1005' ||
          getChannelContextCode(err, 'channel-context') === '1006' ||
          getChannelContextMsg(err, 'channel-context').includes(
            'No data found on ececuser.commoncodes'
          )
        ) {
          dispatch(setError('error_cocd'));
          return;
        }
        dispatch(setError('system'));
        sendEvent({
          category: 'Unexpected Error Credit Scoring 1st Loan',
          action: getJsonStringify(err.response),
          label: param.phoneNo
        });
        sendException({
          desc: getJsonStringify(err.response),
          fatal: true
        });
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

//suplesi
export const submitCreditScoringV3 = (param, body, action) => {
  return dispatch => {
    dispatch(loading(true));
    const url = USERSV3 + '/' + 'custom/suplesi/' + param.applicationId;

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(res => {
        dispatch(setCreditScoringRes(res.data.data));
        dispatch(
          setApplicationStatus(res.data.data?.applicationStatus?.cmCode)
        );
        localStorage.setItem('setCSFromFormFill', 1);
        dispatch(
          setTimer({
            minutes: res.data.data.timeLeftForScoreCompletion,
            seconds: 0
          })
        );
        dispatch(setCreditScoreResult(''));
        action && action();
      })
      .catch(err => {
        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }

        if (getChannelContextCode(err, 'channel-context') === null) {
          dispatch(setError('system'));
          return;
        }

        // OCR FAILED
        if (getChannelContextCode(err, 'channel-context') === '211051') {
          dispatch(setError('OCR_FAILED'));
          return;
        }

        // PAYROLL ERROR
        if (getChannelContextCode(err, 'channel-context') === '211101') {
          dispatch(setError('PAYROLL_ERROR'));
          return;
        }

        // COCD ERROR
        if (
          getChannelContextCode(err, 'channel-context') === '1005' ||
          getChannelContextCode(err, 'channel-context') === '1006' ||
          getChannelContextMsg(err, 'channel-context').includes(
            'No data found on ececuser.commoncodes'
          )
        ) {
          dispatch(setError('error_cocd'));
          return;
        }
        dispatch(setError('system'));
        sendEvent({
          category: 'Unexpected Error Credit Scoring 1st Loan',
          action: getJsonStringify(err.response),
          label: param.phoneNo
        });
        sendException({
          desc: getJsonStringify(err.response),
          fatal: true
        });
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const secondLoanCreditScoring = (param, body, action) => {
  return async dispatch => {
    dispatch(loading(true));
    const url = `${USERS}/custom/applications/${param.applicationId}`;

    const { signature, timestamp } = generateHmac(
      'POST',
      'applications',
      body,
      true
    );

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp,
        'Content-Type': 'application/json'
      }
    };

    try {
      const res = await axiosGolang.post(url, body, header);
      const data = res.data.data;

      dispatch(setCreditScoringRes(data));
      localStorage.setItem('setCSFromFormFill', 1);
      dispatch(setApplicationId(data.applicationId));
      dispatch(setApplicationStatus(data.applicationStatus.cmCode));
      dispatch(
        setTimer({
          minutes: data.timeLeftForScoreCompletion,
          seconds: 0
        })
      );
      dispatch(setCreditScoreResult(''));
      action?.();
    } catch (err) {
      handleSecondLoanCreditScoringError(dispatch, err, param.phoneNo);
    } finally {
      dispatch(loading(false));
    }
  };
};

//suplesi
export const secondLoanCreditScoringV3 = (param, body, action) => {
  return async dispatch => {
    dispatch(loading(true));
    const url = `${USERSV3}/custom/suplesi/${param.applicationId}`;

    const { signature, timestamp } = generateHmac(
      'POST',
      'applications',
      body,
      true
    );

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp,
        'Content-Type': 'application/json'
      }
    };

    try {
      const res = await axiosGolang.put(url, body, header);
      const data = res.data.data;

      dispatch(setCreditScoringRes(data));
      localStorage.setItem('setCSFromFormFill', 1);
      dispatch(
        setTimer({
          minutes: data.timeLeftForScoreCompletion,
          seconds: 0
        })
      );
      dispatch(setCreditScoreResult(''));
      action?.();
    } catch (err) {
      handleSecondLoanCreditScoringError(dispatch, err, param.phoneNo);
    } finally {
      dispatch(loading(false));
    }
  };
};

export const ktpRejectedToAppExpired = (param, action) => {
  return dispatch => {
    dispatch(loading(true));

    const url =
      USERS + '/custom/applications/' + param.applicationId + '/expired';

    const { signature, timestamp } = generateHmac('PUT', 'applications', '');

    const header = {
      headers: {
        Authorization: param.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .put(url, null, header)
      .then(res => {
        if (res.data.data) {
          dispatch(
            setApplicationStatus(res.data.data.applicationStatus.cmCode)
          );
          dispatch(setApplicationId(res.data.data.applicationId));
          action && action.action();
        }
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }

        dispatch(setError('system'));
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const fetchDisbursementDetail = (auth, param) => {
  return dispatch => {
    dispatch(loading(true));

    const url = `${USERS}/custom/servicerequests/disbursement-status`;
    const body = {
      applicationId: auth.applicationId
    };

    const { signature, timestamp } = generateHmac('PUT', 'applications', body);

    const header = {
      signal: controller.signal,
      headers: {
        Authorization: auth.token,
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
      }
    };

    dispatch(setError(''));

    axiosGolang
      .put(url, body, header)
      .then(res => {
        const data = res.data.data;
        dispatch(setApplicationStatus(data[0].status));
        dispatch(setDisburseLifetime(data[0].disbLifetime));
        dispatch(setDisburseDetail(data[0]));

        dispatch(loading(false));
        if (data?.[0]?.status === 'LOAN_CREATED') param?.action?.();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }

        dispatch(setError('system'));
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const fetchListReferral = (auth, params) => {
  return async dispatch => {
    dispatch(loading(true));

    const url = `${USERS}/custom/data-referral-code?userId=${auth?.phoneNo}`;

    const { signature, timestamp } = generateHmac('GET', 'applications', '');

    try {
      const res = await axiosGolang.get(url, {
        headers: {
          Authorization: auth.token,
          'H-PNG-Signature': signature,
          'H-PNG-Timestamp': timestamp
        }
      });

      const data = res?.data?.data;
      const bannerReferralData = data?.map(item => ({
        header: 'Referral Flexi Apps',
        imagePath: `data:image/png;base64,${item.referralBanner}`,
        referralCode: `${item.referralCode}`
      }));

      dispatch(setListReferralCode(bannerReferralData ? bannerReferralData : []));
    } catch (err) {
      handleApplicationError(dispatch, err, auth, params);
      dispatch(loading(false));
    } finally {
      dispatch(loading(false));
    }
  };
};

export const fetchDetailReferral = (auth, params) => {
  return async dispatch => {
    dispatch(loading(true));

    const url = `${USERS}/custom/data-referral-code?userId=${auth?.phoneNo}&referralCode=${params?.referralCode}`;

    const { signature, timestamp } = generateHmac('GET', 'applications', '');

    try {
      const res = await axiosGolang.get(url, {
        headers: {
          Authorization: auth.token,
          'H-PNG-Signature': signature,
          'H-PNG-Timestamp': timestamp
        }
      });

      const data = res?.data?.data;
      dispatch(setDetailReferralCode(data ? data : []));
    } catch (err) {
      handleApplicationError(dispatch, err, auth, params);
      dispatch(loading(false));
    } finally {
      dispatch(loading(false));
    }
  };
};

export const setApplicationdata = data => {
  return {
    type: actionTypes.RESUME_APPLICATION,
    res: data
  };
};

export const setLoanProduct = product => {
  return {
    type: actionTypes.SET_LOAN_PRODUCT_OPTIONS,
    product: product
  };
};

export const setCustCategory = custCategory => {
  return {
    type: actionTypes.SET_CUST_CATEGORY_OPTIONS,
    custCategory: custCategory
  };
};

export const setLoanAmount = amount => {
  return {
    type: actionTypes.SET_LOAN_AMOUNT,
    amount: amount
  };
};

export const setTenure = tenure => {
  return {
    type: actionTypes.SET_TENURE,
    tenure: tenure
  };
};

export const setLoanPurpose = purpose => {
  return {
    type: actionTypes.SET_LOAN_PURPOSE,
    purpose: purpose
  };
};

export const setAccountNumber = accountNumber => {
  return {
    type: actionTypes.SET_ACCOUNT_NUMBER,
    accountNumber: accountNumber
  };
};

export const registerWhitelist = (data, token, history) => {
  return async dispatch => {
    dispatch(loading(true));
    const url = `${USERS}/custom/payroll-upload`;
    const header = { headers: { Authorization: token } };

    try {
      const res = await axiosGolang.post(url, data, header);
      const responseCode = res.data.code;

      const responseHandlers = {
        '001': () => dispatch(setError('failed_insert')),
        '000': () => history?.push('/whitelist-success')
      };

      if (responseHandlers[responseCode]) {
        responseHandlers[responseCode]();
      }
    } catch (err) {
      handleWhitelistError(dispatch, err);
    } finally {
      dispatch(loading(false));
    }
  };
};

export const accountInquiry = (data, action) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));
    const url = `${USERS}/custom/accountinquiry`;
    const body = {
      ktp: data.ktp,
      acctNo: data.cardNumber,
      bankCode: data.bankCode,
      productCode: '002',
      schemeCode: data.schemeCode,
      subCode: data.subCode
    };
    const header = { headers: { Authorization: data.token } };

    try {
      const res = await axiosGolang.post(url, body, header);
      const responseCode = res.data.code;
      if (responseCode) dispatch(loading(false));

      // Map response codes to error keys
      const errorMap = {
        211047: 'general_error',
        211048: 'contact-cs',
        1008: 'contact-cs',
        5100: 'account_bri_not_found',
        211042: 'expiry_date_mismatch',
        211049: 'account_is_not_open',
        211050: 'incorrect_ktp',
        211051: 'entered_ktp_number_is_not_correct',
        211091: 'user_unabled_to_do_atm_inquiry_for_15_minutes',
        211097: 'nik_is_already_registered',
        211052: 'getting_older_young',
        211053: 'error_minimum_balance'
      };

      if (errorMap[responseCode]) {
        dispatch(setError(errorMap[responseCode]));
        return;
      }

      const result = res.data.data;
      if (result) {
        const [inqRes] = result;
        dispatch(setAtmInqRes(result));
        dispatch(setCustomerName(inqRes.silverLakeCIFInquiryReferenceVO.nama));
        dispatch(
          setWhitelistAddress(
            inqRes.silverLakeCIFInquiryReferenceVO.address,
            null
          )
        );

        if (inqRes.rayanetInquiryReferenceVO) {
          dispatch(setRayanetInqRes(inqRes.rayanetInquiryReferenceVO));
        }

        if (inqRes.kasbonReferenceVO) {
          handleKasbonAcctInq(dispatch, inqRes.kasbonReferenceVO);
        }

        const isSecondApply = getState().loanApply.isSecondApply;
        const isRayaEmployed = inqRes.whitelistReferenceVO?.isRayaEmployed;

        if (isSecondApply !== 'Y') {
          dispatch(setIsRayaEmployed(isRayaEmployed || 'N'));
        }
      }

      // centralized action handlers
      action?.approve?.();
      action?.payrollverf?.(res.data.data?.[0]);
      action?.push?.();
    } catch (err) {
      sendEvent({
        category: 'Error ATM Inquiry Verification',
        action: JSON.stringify(err.response),
        label: data.phoneNo
      });

      dispatch(loading(false));

      if (!err.response) return dispatch(setError('connection'));
      if (err.response.status === 422) return dispatch(setError('miss_match'));

      const channelCode = getChannelContextCode(err, 'channel-context');
      const channelErrorMap = {
        1026: 'contact-cs',
        1008: 'error_cocd',
        null: 'system'
      };

      dispatch(setError(channelErrorMap[channelCode] || 'system'));
    }
  };
};

export const setProductConfig = config => {
  return {
    type: actionTypes.SET_PRODUCT_CONFIG,
    rate: config.rate,
    code: config.code,
    category: config.category,
    subCategory: config.subCategory,
    schemeCode: config.schemeCode,
    installment: config.installment
  };
};

export const setApplicationId = id => {
  return {
    type: actionTypes.SET_APPLICATION_ID,
    id: id
  };
};

export const setApplicationIdV3 = id => {
  return {
    type: actionTypes.SET_APPLICATION_ID_V3,
    id: id
  };
};

export const setIsFlowSuplesiActive = value => {
  return {
    type: actionTypes.SET_FLOW_SUPLESI_ACTIVE,
    value: value
  };
};

export const setApplicationStatus = status => {
  return {
    type: actionTypes.SET_APPLICATION_STATUS,
    status: status
  };
};

export const setApplicationStatusV3 = status => {
  return {
    type: actionTypes.SET_APPLICATION_STATUS_V3,
    status: status
  };
};

export const setNextDate = nextDate => {
  return {
    type: actionTypes.SET_NEXT_DATE,
    nextDate: nextDate
  };
};

export const setResponseCodeReject = responseCodeReject => {
  return {
    type: actionTypes.SET_RESPONSE_CODE_REJECT,
    responseCodeReject: responseCodeReject
  };
};

export const setAppInqRes = res => {
  return {
    type: actionTypes.SET_APP_INQUIRY_RESPONSE,
    res: res
  };
};

export const setAppInqResV3 = res => {
  return {
    type: actionTypes.SET_APP_INQUIRY_V3_RESPONSE,
    res: res
  };
};

export const setApprovalDetails = data => {
  return {
    type: actionTypes.SET_APPROVAL_DETAILS,
    data: data
  };
};

export const setIncompleteApp = data => {
  return {
    type: actionTypes.SET_INCOMPLETE_APP,
    data: data
  };
};

export const setEktp = ektp => {
  return {
    type: actionTypes.SET_EKTP,
    ektp: ektp
  };
};

export const setEktpRaya = eKTPRaya => {
  return {
    type: actionTypes.SET_EKTP_RAYA,
    eKTPRaya: eKTPRaya
  };
};

export const setBankCode = source => {
  return {
    type: actionTypes.SET_BANK_CODE,
    source: source
  };
};

export const setCardNumber = cardNo => {
  return {
    type: actionTypes.SET_CARD_NUMBER,
    cardNumber: cardNo
  };
};

export const setCardExpDate = expDate => {
  return {
    type: actionTypes.SET_CARD_EXPIRED_DATE,
    expDate: expDate
  };
};

export const setAtmInqRes = response => {
  return {
    type: actionTypes.SET_ATM_INQUIRY_RESPONSE,
    response: response
  };
};

export const setCustomerName = custName => {
  return {
    type: actionTypes.SET_CUSTOMER_NAME,
    name: custName
  };
};

export const setDisburseLifetime = disburseLifetime => {
  return {
    type: actionTypes.SET_DISBURSE_LIFETIME,
    disburseLifetime: disburseLifetime
  };
};

export const setSubtractionDisburseLifeTime = () => {
  return {
    type: actionTypes.SET_SUBTRACTION_DISBURSE_LIFETIME
  };
};

export const setLoanPurposeOptions = options => {
  return {
    type: actionTypes.SET_LOAN_PURPOSE_OPTIONS,
    options: options
  };
};

export const setBankOptions = bankCodes => {
  return {
    type: actionTypes.SET_BANK_OPTIONS,
    bankCodes: bankCodes
  };
};

export const setPlaceOfBirthOptions = options => {
  return {
    type: actionTypes.SET_PLACEOFBIRTH_OPTIONS,
    options: options
  };
};

export const setEducationOptions = options => {
  return {
    type: actionTypes.SET_EDUCATION_OPTIONS,
    options: options
  };
};
export const setFieldOfWorkOptions = options => {
  return {
    type: actionTypes.SET_FIELD_OF_WORK_OPTIONS,
    options: options
  };
};
export const setFieldOfBusinessOptions = options => {
  return {
    type: actionTypes.SET_FIELD_OF_BUSINESS_OPTIONS,
    options: options
  };
};

export const setFieldOfSubBusinessOptions = options => {
  return {
    type: actionTypes.SET_FIELD_OF_SUB_BUSINESS_OPTIONS,
    options: options
  };
};

export const setProvinceOptions = options => {
  return {
    type: actionTypes.SET_PROVINCE_OPTIONS,
    options: options
  };
};

export const setCityOptions = options => {
  return {
    type: actionTypes.SET_CITY_OPTIONS,
    options: options
  };
};

export const setCityKtpOptions = options => {
  return {
    type: actionTypes.SET_CITY_KTP_OPTIONS,
    options: options
  };
};

export const setSubDistrictOptions = options => {
  return {
    type: actionTypes.SET_SUB_DISTRICT_OPTIONS,
    options: options
  };
};

export const setSubDistrictKtpOptions = options => {
  return {
    type: actionTypes.SET_SUB_DISTRICT_KTP_OPTIONS,
    options: options
  };
};

export const setVillageOptions = options => {
  return {
    type: actionTypes.SET_VILLAGE_OPTIONS,
    options: options
  };
};

export const setVillageKtpOptions = options => {
  return {
    type: actionTypes.SET_VILLAGE_KTP_OPTIONS,
    options: options
  };
};

export const setJobTitleOptions = options => {
  return {
    type: actionTypes.SET_JOB_TITLE_OPTIONS,
    options: options
  };
};

export const setDailyNormalTransactionsOptions = options => {
  return {
    type: actionTypes.SET_DAILY_NORMAL_TRANSACTIONS_OPTIONS,
    options: options
  };
};

export const setReligionsOptions = options => {
  return {
    type: actionTypes.SET_RELIGION_OPTIONS,
    options: options
  };
};

export const setResidenceOptions = options => {
  return {
    type: actionTypes.SET_RESIDENCE_OPTIONS,
    options: options
  };
};

export const setTypeOfWorkOptions = options => {
  return {
    type: actionTypes.SET_TYPE_OF_WORK_OPTIONS,
    options: options
  };
};

export const setEmployeeOptions = options => {
  return {
    type: actionTypes.SET_EMPLOYEE_OPTIONS,
    options: options
  };
};

export const setPurposeOfOpeningAccountOptions = options => {
  return {
    type: actionTypes.SET_PURPOSE_OF_OPENING_ACCOUNT_OPTIONS,
    options: options
  };
};

export const setSourceOfIncomeOptions = options => {
  return {
    type: actionTypes.SET_SOURCE_OF_INCOME_OPTIONS,
    options: options
  };
};

export const setCompanyOptions = options => {
  return {
    type: actionTypes.SET_COMPANY_OPTIONS,
    options: options
  };
};

export const appendCompanyOptions = options => {
  return {
    type: actionTypes.APPEND_COMPANY_OPTIONS,
    options: options
  };
};

export const setCompanyPagination = pagination => {
  return {
    type: actionTypes.SET_COMPANY_PAGINATION,
    pagination: pagination
  };
};

export const setCompanyLoadingMore = value => {
  return {
    type: actionTypes.SET_COMPANY_LOADING_MORE,
    value: value
  };
};

export const setDependentsOptions = options => {
  return {
    type: actionTypes.SET_DEPENDENTS_OPTIONS,
    options: options
  };
};

export const setMarriageOptions = options => {
  return {
    type: actionTypes.SET_MARRIAGE_OPTIONS,
    options: options
  };
};

export const setRelativesOptions = options => {
  return {
    type: actionTypes.SET_RELATIVES_OPTIONS,
    options: options
  };
};

export const setVerifyPayroll = data => {
  return {
    type: actionTypes.SET_VERIFY_PAYROLL,
    data: data
  };
};

export const setApplicationDetails = data => {
  return {
    type: actionTypes.SET_APPLICATION_DETAILS,
    data: data
  };
};

export const setDocumentDetails = data => {
  return {
    type: actionTypes.SET_DOCUMENT_DETAILS,
    data: data
  };
};

export const setRespPayrollDetails = data => {
  return {
    type: actionTypes.SET_RESP_PAYROLL_DETAILS,
    data: data
  };
};

export const setEktpImg = value => {
  return {
    type: actionTypes.SET_EKTP_IMG,
    value: value
  };
};

export const setPersonInfo = data => {
  return {
    type: actionTypes.SET_PERSON_INFO,
    personInfo: data
  };
};

export const setKtpAddressDetails = data => {
  return {
    type: actionTypes.SET_KTP_ADDRESS_DETAILS,
    data: data
  };
};

export const setOccupationInfo = data => {
  return {
    type: actionTypes.SET_OCCUPATION_INFO,
    occupationInfo: data
  };
};

export const setFamilyInfo = data => {
  return {
    type: actionTypes.SET_FAMILY_INFO,
    familyInfo: data
  };
};

export const setCreditScoringRes = res => {
  return {
    type: actionTypes.CREDIT_SCORE_RESPONSE,
    res: res
  };
};

export const setWhitelistAddress = (whitelistAddress, applicantDetails) => {
  const addresses = whitelistAddress && whitelistAddress.split('|');
  const fullAddress = addresses && addresses.length > 0 ? addresses[0] : '';
  const address = {
    fullAddress,
    haveSameAddress: false
  };

  if (applicantDetails && applicantDetails.addressLine1) {
    Object.assign(address, {
      haveSameAddress: applicantDetails.addressLine1 === fullAddress
    });
  }

  return {
    type: actionTypes.SET_WHITELIST_ADDRESS,
    whitelistAddress: address
  };
};

export const setSecondApply = data => {
  return {
    type: actionTypes.SET_SECOND_APPLY,
    set: data
  };
};

export const setCompanyName = val => {
  return {
    type: actionTypes.SET_COMPANY_NAME,
    data: val
  };
};

export const setCompanyAddress = val => {
  return {
    type: actionTypes.SET_COMPANY_ADDRESS,
    data: val
  };
};

export const dehydrateData = () => {
  return {
    type: actionTypes.SET_DEHYDRATE_DATA
  };
};

export const setSubCodeLoanScheme = payload => {
  return {
    type: actionTypes.SET_SUBCODE_LOANSCHEME,
    payload: payload
  };
};

export const setLoanSchemes = payload => {
  return {
    type: actionTypes.SET_LOAN_SCHEMES,
    payload: payload
  };
};

export const setLoanScheme = payload => {
  return {
    type: actionTypes.SET_LOAN_SCHEME,
    payload: payload
  };
};

export const setLoanFee = payload => {
  return {
    type: actionTypes.SET_LOAN_FEE,
    payload: payload
  };
};

export const setAttemptSubmission = payload => {
  return {
    type: actionTypes.SET_ATTEMPT_SUBMISSION,
    payload
  };
};

export const setShouldManualCheck = payload => {
  return {
    type: actionTypes.SHOULD_MANUAL_CHECK,
    payload
  };
};

export const setNPWP = payload => {
  return {
    type: actionTypes.SET_NPWP,
    payload
  };
};

export const handleAbortResubmitKTP = (isAbort = false) => {
  return dispatch => {
    if (isAbort) {
      controller.abort();
      dispatch(setError('ERR_CANCELED'));
      return;
    }
    controller = new AbortController();
    return;
  };
};

export const setRayanetInqRes = payload => {
  return {
    type: actionTypes.SET_RAYANET_INQUIRY,
    payload
  };
};

export const setAccountInformationInq = payload => {
  return {
    type: actionTypes.SET_ACCOUNT_INFORMATION_APP_INQ,
    payload
  };
};

export const setAccountRayaInformation = payload => {
  return {
    type: actionTypes.SET_ACCOUNT_RAYA_INFORMATION,
    payload
  };
};

export const setNpwpImg = value => {
  return {
    type: actionTypes.SET_NPWP_IMAGE,
    value
  };
};

export const setAccountRayaSavingExist = payload => {
  return {
    type: actionTypes.SET_ACCOUNT_RAYA_SAVING_EXIST,
    payload
  };
};

export const setAcctCreatedFromSaving = acctCreatedFromSaving => {
  return {
    type: actionTypes.SET_ACCT_CREATED_FROM_SAVING,
    acctCreatedFromSaving: acctCreatedFromSaving
  };
};

export const setIsExistWhitelist = payload => {
  return {
    type: actionTypes.SET_IS_EXIST_WHITELIST,
    payload
  };
};

export const setKtpSubmitFormRes = payload => {
  return {
    type: actionTypes.SET_KTP_SUBMIT_FORM_RES,
    payload
  };
};

export const setRespKtpSubmit = payload => {
  return {
    type: actionTypes.SET_RESP_KTP_SUBMIT,
    payload
  };
};

export const setKasbonInqRes = payload => {
  return {
    type: actionTypes.SET_KASBON_INQUIRY,
    payload
  };
};

export const setIsCompanyUpdated = payload => {
  return {
    type: actionTypes.SET_IS_COMPANY_UPDATED,
    payload
  };
};

export const setIsSameContactOther = payload => {
  return {
    type: actionTypes.SET_IS_SAME_CONTACT_OTHER,
    payload
  };
};

export const setFlagBoxs = payload => {
  return {
    type: actionTypes.SET_FLAGBOX,
    payload
  };
};

export const setBottomSheet = payload => {
  return {
    type: actionTypes.SET_BOTTOM_SHEET,
    payload
  };
};

export const setWhitelistBottomSheet = payload => {
  return {
    type: actionTypes.SET_WHITELIST_BOTTOM_SHEET,
    payload
  };
};

export const setBlockScreen = payload => {
  return {
    type: actionTypes.SET_BLOCK_SCREEN,
    payload
  };
};

export const setIsMaintenance = payload => {
  return {
    type: actionTypes.SET_IS_MAINTENANCE,
    payload
  };
};

export const setShowSuccessChangeNumber = payload => {
  return {
    type: actionTypes.SET_SHOW_SUCCESS_CHANGE_NUMBER,
    payload
  };
};

export const setDocRiplay = doc => {
  return {
    type: actionTypes.SET_DOC_RIPLAY,
    doc: doc
  };
};

export const setIsCustomerConsent = value => {
  return {
    type: actionTypes.SET_IS_CUSTOMER_CONSENT,
    isCustomerConsent: value
  };
};

export const setFreezeDateSuccess = value => {
  return {
    type: actionTypes.SET_FREEZE_DATE_SUCCESS,
    freezeDateSuccess: value
  };
};

export const setIsUsingForm = value => {
  return {
    type: actionTypes.SET_IS_USING_FORM,
    isUsingForm: value
  };
};

export const setIsRayaEmployed = value => {
  return {
    type: actionTypes.SET_IS_RAYA_EMPLOYED,
    isRayaEmployed: value
  };
};

export const setIsUpdateReferralCode = value => ({
  type: actionTypes.SET_IS_UPDATE_REFERRAL_CODE,
  isUpdateReferralCode: value
});

export const setMaintenanceWait = value => {
  return {
    type: actionTypes.SET_MAINTENANCE_WAIT,
    isMaintenanceWait: value
  };
};

export const setExpiredData = value => {
  return {
    type: actionTypes.SET_EXPIRED_DATA,
    expiredData: value
  };
};

export const setEligibleMgm = data => {
  return {
    type: actionTypes.SET_ELIGIBLE_MGM,
    set: data
  };
};

export const setListReferralCode = data => {
  return {
    type: actionTypes.SET_LIST_REFERRAL_CODE,
    data: data
  };
};

export const setDetailReferralCode = data => {
  return {
    type: actionTypes.SET_DETAIL_REFERRAL_CODE,
    data: data
  };
};
